<template>
  <div>
    <div class="card shadow">
      <a id="button"></a>
      <div class="card-header bg-transparent">
        <div>
          <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>         
          <h3 class="mb-0">
            {{ $t('message.Listsligne') }}
          </h3>
        </div>
      </div>
    
      <div class="card-body" v-if="!mobileView">
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>Date consultation</th>
                            <th>Motifs</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,key) in timelines" :key="'ligne'+key">
                        <td>{{ item.date_consultation }}</td>
                        <td>
                            <ul v-if="item.motifs.length > 0">
                                <li v-for="(motif,key) in item.motifs" :key="'motif'+key">{{ motif.description }}</li>
                            </ul>
                            <span v-else>
                              {{ item.motif.description }}
                            </span>
                        </td>
                        <td v-if="item.cloture">
                          <b-button variant="danger" v-if="item.cloture.ama == null" @click="cloturerContract(item.id)">
                          {{ $t('message.cloturer') }}
                          </b-button>
                          <span v-else class="font-weight-bold">
                            {{ formattedDateTime(item.cloture.ama) }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                </table>
            </div> 
      </div>

      <b-row v-if="mobileView">
            <div  v-for="(item,key) in timelines" :key="'ligne'+key" class="mt-3"> 
                    <!-- <div class=""> -->

                  <div class="list-group-item"><p class=""><span class="new-title">Date consultation</span>: <span class="font-weight-bold text-gray mr-4">{{ item.date_consultation }}</span></p></div>
                  <div class="list-group-item">
                      <p class="" v-if="item.motifs.length > 0">
                          <span class="new-title">Motifs</span>: <span class="font-weight-bold text-gray"  v-for="(motif,key) in item.motifs" :key="'motif'+key">
                                  {{ motif.description }}
                          </span>
                      </p>
                      <span v-else>
                        {{ item.motif.description }}
                      </span>
                    
                  </div>
                  <div class="list-group-item d-flex justify-content-center" v-if="item.cloture">
                      <b-button variant="danger" v-if="item.cloture.ama == null" @click="cloturerContract(item.id)">
                          {{ $t('message.cloturer') }}
                          </b-button>
                          <span v-else class="font-weight-bold">
                            {{ formattedDateTime(item.cloture.ama) }}
                          </span>                   
                  </div> 
                            <hr>
            </div>
        </b-row>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import moment from "moment";
import AppConfig from "../../constants/AppConfig";

export default {
  name: "TimeLinePatient",
  computed: {
    
  },
  data() {
    return {
      mobileView: true,
      timelines: [],
      loading: false,
    }
  },

  methods: {
    handleView() {
                this.mobileView = window.innerWidth <= 990;
            },
    getTimeLines(){
        this.loading = true;
        fetch(AppConfig.apiUrl+`/timelines/${this.$route.params.file}/patient`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
            .then(res => res.json())
        .then(res => {
          this.timelines = res;
        }).catch(error => {
            console.log('error ', error);
        })
    },
    cloturerContract(id){
      let args = {
        id: id
      };
      axios.post(AppConfig.apiUrl+`/clotures/ligne-temps`, args, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}}).then(res => {
        let ligne_temps = this.timelines.find(item  => item.id == id);
        ligne_temps.cloture = res.data;
        this.timelines = this.timelines.map(item => item.id == id ? ligne_temps : item);
        Vue.swal("La clôture de la ligne de temps par l'ama a été effectué avec succès", '', 'success');
      });
    },
    formattedDateTime(date) {
      if (moment(date).isValid() && date != null) {
        return moment(date).format("DD-MM-YYYY à HH:mm");
      } else {
        return date;
      }
    },
  },
  created() {
              this.handleView();
              window.addEventListener('resize', this.handleView);
          },
  mounted() {
    this.getTimeLines();
  }
}
</script>